import { Box, Typography, useTheme } from '@mui/joy';

interface AnalysisHeadingProps {
	number: string;
	title: string;
	anchor?: string;
}
export const AnalysisHeading = ({
	number,
	title,
	anchor
}: AnalysisHeadingProps) => {
	const theme = useTheme();
	return (
		<Box
			id={anchor}
			sx={{
				borderTop: '1px solid black',
				borderBottom: '1px solid black',
				paddingTop: '10px',
				paddingBottom: '30px',
				backgroundColor: theme.palette.chartElementsBackground.bg
			}}
		>
			<Typography level='h1' sx={{ marginTop: '10px', textAlign: 'center' }}>
				{number}
			</Typography>
			<Typography
				level='h2'
				sx={{
					marginTop: '10px',
					textAlign: 'center',
					fontWeight: '300',
					fontSize: '2.625rem',
					lineHeight: '3rem'
				}}
			>
				{title}
			</Typography>
		</Box>
	);
};
